<template>
  <div>
    <div class="card-msg">
      <div style="margin: 0 40px">
        <div style="padding-top: 20px;height: 20px;line-height: 20px;font-size: 18px">
          <strong>呼入时间：{{phoneObj.time}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;
          <strong>呼入号码：{{phoneObj.alarmphone}}</strong>&nbsp;&nbsp;&nbsp;&nbsp;
<!--          <img src="../../assets/phoneIcon/phone_btn.png" style="vertical-align: middle">-->
          <div class="phone-item-box" v-if="phoneListObj.isTable">
            <img src="../../assets/phoneIcon/phone_btn.png" style="vertical-align: middle;cursor: pointer" @click="editCallPhone(phoneObj.alarmphone)">
          </div>
        </div>
      </div>
    </div>
    <div>
      <el-row>
        <el-col :span="8">
          <div style="margin: 15px 20px;font-size: 18px;height: 40px;line-height: 40px">
            <span style="color: #C0C4CC;">请选择或新建服务对象进行下一步处理。</span>
          </div>
        </el-col>
        <el-col :span="16">
          <div style="margin: 15px 20px;text-align: right">
<!--            <el-input style="width: 200px" placeholder="输入姓名搜索" v-model="searchKeyword">-->
<!--              <el-button type="primary" slot="append" icon="el-icon-search"></el-button>-->
<!--            </el-input>-->
            <el-input
              placeholder="输入姓名搜索"
              v-model="searchKeyword"
              style="width: 250px"
              @blur="searchWord1()">
            </el-input>
            <el-button style="margin-left: -7px" type="primary" icon="el-icon-search" @click="searchWord()"></el-button>
            <el-button icon="el-icon-plus" type="primary" @click="addOpen()">新建</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="height: 330px;margin: 0 20px">
      <el-table
        size="mini"
        v-loading="loading"
        element-loading-text="加载中，请耐心等待。"
        :data="showTable"
        border
        height="100%"
        style="width: 100%"
        highlight-current-row
        ref="tableData"
        @row-click="singleElection"
        :cell-style="cellStyle">
        <!--tbdata-->
        <el-table-column label="" width="65" align="center">
          <template slot-scope="scope">
            <el-radio class="radio" v-model="templateSelection" :label="scope.$index">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          min-width="60"
          align="center">
        </el-table-column>
        <el-table-column
          label="性别"
          width="50"
          align="center">
          <template slot-scope="scope">
            <span>{{getSex(scope.row.sex)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="birthday"
          label="出生日期"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="电话号码"
          min-width="90"
          align="center">
        </el-table-column>
        <el-table-column
          prop="h_address"
          label="家庭地址"
          min-width="90"
          align="center">
        </el-table-column>
        <el-table-column
          label="服务频率"
          min-width="70"
          align="center">
          <!-- prop="frequency"-->
          <template slot-scope="scope">
            <span>{{getFrequencyName(scope.row)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="所属项目"
          min-width="70"
          align="center">
          <!-- prop="projectname"-->
          <template slot-scope="scope">
            <span>{{getProjectName(scope.row)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="项目备注"
          min-width="70"
          align="center">
          <!--prop="projectremark"-->
          <template slot-scope="scope">
            <span>{{getProjectRemark(scope.row)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="身份证号"
          min-width="100"
          align="center">
          <template slot-scope="scope">
            <span>{{getIDcard(scope.row.idcard_num)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="circumstances"
          label="特殊情况"
          min-width="90"
          align="center">
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 20px">
      <el-row>
        <el-col :span="12">
          <div class="send-btn" @click="handleNow()">
            <span>下一步</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="red-btn" @click="submitHandle()">
            <span>误打电话</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="clear:both;height: 25px;text-align: center;padding-top: 10px">
      <span style="color: red;">{{hit}}</span>
    </div>
  </div>
</template>

<script>
import {searchpersonbyphone, hanlealarm} from '../../api/handlealarm'
import {makePhoneCall} from '../../sip/sip_index'
import {searcholdperson} from '../../api/serviceObject'
import {sendSub} from '../../mq'
export default {
  name: 'phoneinOldPersonList',
  props: {
    phoneListObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      searchKeyword: '',
      hit: '',
      row: '',
      templateSelection: '',
      templateRadio: '',
      showTable: [],
      loading: false,
      frequencys: [],
      projects: [],
      phoneObj: {
        alarmphone: '',
        time: ''
      },
      alarmid: ''
    }
  },
  created () {
    console.log(this.phoneListObj)
    // this.showTable = this.phoneListObj.listTable
    this.frequencys = this.phoneListObj.frequencys
    this.projects = this.phoneListObj.projects
    if (this.phoneListObj.isTable) {
      this.alarmid = this.phoneListObj.alarmRow.id
      this.phoneObj.alarmphone = this.phoneListObj.alarmRow.alarmphone
      this.phoneObj.time = this.phoneListObj.alarmRow.time
    } else {
      this.alarmid = this.phoneListObj.alarmMsg.id
      this.phoneObj.alarmphone = this.phoneListObj.alarmMsg.phone
      this.phoneObj.time = this.phoneListObj.alarmMsg.time
    }
    this.getOldPersonTableByPhone()
  },
  methods: {
    editCallPhone (phoneNum) {
      if (phoneNum.slice(0, 3) === '021') {
        return
      }
      makePhoneCall(phoneNum)
      this.$notify({
        title: '成功',
        message: '正在呼叫，请注意接听电话，用以呼叫',
        type: 'success',
        duration: 1000
      })
    },
    // 通过手机号查找服务对象
    getOldPersonTableByPhone () {
      let data = {
        phone: ''
      }
      if (this.phoneListObj.isTable) {
        data.phone = this.phoneListObj.alarmRow.alarmphone
      } else {
        data.phone = this.phoneListObj.alarmMsg.phone
      }
      searchpersonbyphone(data).then(res => {
        this.row = ''
        this.templateSelection = ''
        this.templateRadio = ''
        this.hit = ''
        this.showTable = res.data.person
        // console.log(this.showTable)
      }).catch(() => {})
    },
    cellStyle ({row, column, rowIndex, columnIndex}) {
      // console.log(row, column, rowIndex, columnIndex)
      if (this.row === row) {
        return 'font-size: 14px!important;background-color: #ecf5ff!important;font-weight:bold!important'
      }
    },
    singleElection (row) {
      this.row = row
      this.templateSelection = this.showTable.indexOf(row)
      this.templateRadio = row.id
      this.hit = ''
    },
    getSex (sex) {
      return this.util.getSex(sex + '')
    },
    getProjectRemark (row) {
      let projectremark = ''
      for (let i = 0; i < this.projects.length; i++) {
        if (row.projectid === this.projects[i].id) {
          projectremark = this.projects[i].remark
        }
      }
      return projectremark
    },
    getIDcard (num) {
      // console.log(num)
      if (num.length === 18) {
        let aa = num.substring(num.length - 4)
        return '**************' + aa
      }
    },
    getProjectName (row) {
      let projectname = ''
      for (let i = 0; i < this.projects.length; i++) {
        if (row.projectid === this.projects[i].id) {
          projectname = this.projects[i].projectname
        }
      }
      return projectname
    },
    getFrequencyName (row) {
      let frequency = ''
      for (let i = 0; i < this.frequencys.length; i++) {
        if (row.frequencyid === this.frequencys[i].id) {
          frequency = this.frequencys[i].frequency
        }
      }
      return frequency
    },
    handleNow () {
      // console.log(this.row)
      let obj = {
        type: 'next',
        row: this.row
      }
      if (this.row !== '') {
        this.$emit('getFatherList', obj)
      } else {
        this.hit = '请选择服务对象'
      }
    },
    submitHandle () {
      let data = {
        aid: this.alarmid,
        so_id: 0,
        st_id: 0,
        content: '误打电话',
        pid: 0,
        hid: 0
      }
      hanlealarm(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功处理该警报',
          type: 'success',
          duration: 2000
        })
        let mqtts = this.$store.state.user.mqtts
        let name = this.$store.state.user.personname
        let jobnum = this.$store.state.user.syspersonjobnum
        let dohandle = {id: this.alarmid, name: name, jobnum: jobnum}
        sendSub('/handledone' + mqtts[0], JSON.stringify(dohandle))
        this.store2.dispatch('other/update_del_alarm', this.alarmid).then(() => {
          if (this.$route.path === '/handleAlarm') {
            this.golobleObject.updateTableAlarm()
          }
        })
        let obj = {type: 'close'}
        this.$emit('getFatherList', obj)
      }).catch(() => {})
    },
    addOpen () {
      let obj = {
        type: 'add'
      }
      this.$emit('getFatherList', obj)
    },
    searchWord1 () {
      if (this.searchKeyword === '') {
        this.getOldPersonTableByPhone()
      }
    },
    searchWord () {
      if (this.searchKeyword !== '') {
        let data = {
          lessname: this.searchKeyword,
          page: 1,
          size: 888
        }
        searcholdperson(data).then(res => {
          this.row = ''
          this.templateSelection = ''
          this.templateRadio = ''
          this.hit = ''
          this.showTable = res.data.persons
          // console.log(this.showTable)
        }).catch(() => {
        })
      } else {
        this.getOldPersonTableByPhone()
      }
    }
  }
}
</script>

<style scoped>
  .phone-item-box{
    height: 30px;
    width: 40px;
    text-align: center;
    float: right;
  }
  .phone-item{
    cursor: pointer;
    width: 60px;
    height: 30px;
    line-height: 30px;
    background-image: linear-gradient(0deg,
    #1684fc 0%,
    #66b2ff 100%);
    border-radius: 15px;
    color: white;
    /*float: left;*/
  }
  .card-msg{
    width: 660px;
    height: 60px;
    background: url("../../assets/window_card.png") no-repeat;
    background-size: 100% 100%;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/view/components/phoneinOldPersonList.vue